import { useRef, useCallback, useEffect } from 'react';

interface UseAutoResizeTextareaOptions {
  minHeight?: number;
  maxHeight?: number;
}

export const useAutoResizeTextarea = (
  value: string,
  { minHeight = 40, maxHeight = 100 }: UseAutoResizeTextareaOptions = {}
) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const resize = useCallback(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = `${minHeight}px`;
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
  }, [minHeight, maxHeight]);

  useEffect(() => {
    resize();
  }, [value, resize]);

  return { textareaRef, minHeight, maxHeight };
};
